import * as React from 'react';
import './LoadingSpinner.scss';

interface Props {
  pending: boolean;
}

const LoadingSpinner: React.SFC<Props> = ({ pending }) => {
  if (pending) {
    return (
      <div className="spinner">
        <div className="rect1" />
        <div className="rect2" />
        <div className="rect3" />
        <div className="rect4" />
      </div>
    );
  } else {
    return null;
  }
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/utils/LoadingSpinner/LoadinSpinner.tsx